// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file driver_incident_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DriverIncidentListRequestSchema, DriverIncidentListSchema, DriverIncidentSchema, JobIncidentCreateRequestSchema } from "./driver_incident_pb";
import { file_driver_incident } from "./driver_incident_pb";

/**
 * Describes the file driver_incident_service.proto.
 */
export const file_driver_incident_service: GenFile = /*@__PURE__*/
  fileDesc("Ch1kcml2ZXJfaW5jaWRlbnRfc2VydmljZS5wcm90bxIJcmFjY29vbmFpMswBChVEcml2ZXJJbmNpZGVudFNlcnZpY2USXAoTTGlzdERyaXZlckluY2lkZW50cxIkLnJhY2Nvb25haS5Ecml2ZXJJbmNpZGVudExpc3RSZXF1ZXN0Gh0ucmFjY29vbmFpLkRyaXZlckluY2lkZW50TGlzdCIAElUKEUNyZWF0ZUpvYkluY2lkZW50EiMucmFjY29vbmFpLkpvYkluY2lkZW50Q3JlYXRlUmVxdWVzdBoZLnJhY2Nvb25haS5Ecml2ZXJJbmNpZGVudCIAQgZaBC4vcGI", [file_driver_incident]);

/**
 * @generated from service raccoonai.DriverIncidentService
 */
export const DriverIncidentService: GenService<{
  /**
   * @generated from rpc raccoonai.DriverIncidentService.ListDriverIncidents
   */
  listDriverIncidents: {
    methodKind: "unary";
    input: typeof DriverIncidentListRequestSchema;
    output: typeof DriverIncidentListSchema;
  },
  /**
   * A dispatcher records why a job was not carried out; the job's newest incident is its reason.
   *
   * @generated from rpc raccoonai.DriverIncidentService.CreateJobIncident
   */
  createJobIncident: {
    methodKind: "unary";
    input: typeof JobIncidentCreateRequestSchema;
    output: typeof DriverIncidentSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_driver_incident_service, 0);

